import React, {useMemo} from 'react';

import {ForecastQueryRenderer} from '../../../../../../../ForecastQueryRenderer';
import {RelayProps} from '../../../../../../../relay-helpers/TSRelayConverter';
import TimeRegistrationModalCreate, {
	TimeRegistrationModalCreateProps,
	TimeRegistrationModalCreateQuery,
} from '../TimeRegistrationModalCreate';
import Util from '@/forecast-app/shared/util/util';
import type {TimeRegistrationModalCreate_viewer} from '../__generated__/TimeRegistrationModalCreate_viewer.graphql';
import {TimeRegistrationEntityId} from '../types/TimeRegistrationEntityId';
import {TimeRegistrationInitialState} from '../types/TimeRegistrationInitialState';

type TimeRegistrationModalCreateQueryWrapperProps = Omit<TimeRegistrationModalCreateProps, 'viewer'> & {
	personId: string;
	entityId: TimeRegistrationEntityId | null;
	companyTaskId?: string;
	companyProjectId?: string;
	closeModal: () => void;
	showAsModal?: boolean;
	initialState?: TimeRegistrationInitialState;
	personLabel?: string;
	taskId?: string;
};

function TimeRegistrationModalCreateQueryWrapper({
	taskId,
	personId,
	entityId,
	companyTaskId,
	companyProjectId,
	...modalProps
}: TimeRegistrationModalCreateQueryWrapperProps): JSX.Element {
	taskId = useMemo(() => {
		const showTaskId = taskId ? taskId : Util.getUrlQueryParameter('showTaskId');

		if (showTaskId) {
			Util.clearUrlQueryParameter('showTaskId');
		}

		return showTaskId;
	}, []);

	return (
		<ForecastQueryRenderer
			key="query-render-time_reg_modal_create"
			query={TimeRegistrationModalCreateQuery}
			fetchPolicy={'network-only'}
			modal={true}
			variables={{taskId, companyTaskId, companyProjectId, personId}}
			render={(relayProps: RelayProps<TimeRegistrationModalCreate_viewer>) => {
				return <TimeRegistrationModalCreate {...relayProps} personId={personId} entityId={entityId} {...modalProps} />;
			}}
		/>
	);
}

export default TimeRegistrationModalCreateQueryWrapper;
